import CircularProgress from '@mui/material/CircularProgress';

// TODO: add size prop and reuse everywhere
const ActivityIndicator = () => {
  return (
    <CircularProgress
      sx={{
        position: 'absolute',
        width: '100px',
        height: '100px',
        top: 'calc(50% - 25px)',
        left: 'calc(50% - 25px)'
      }}
    />
  );
};

export default ActivityIndicator;
